const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const OfficeModal = require("./OfficeModal");
const LoadingCircle = require("../../core/view/LoadingCircle");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const ImageLoader = require("../../core/util/ImageLoader");
const Analytics = require("../../core/util/Analytics");
const CopyTable = require("../data/CopyTable");
const AssetsUtil = require("../../core/util/AssetsUtil");

const styles = require("./styles/LoginModal.css");
const getResetCopy = CopyTable.getResetCopy;

/*
TODO: This and ChangeEmailModal have a lot in common.
They should perhaps share a component or subcomponents.
*/

// We set this flag to false for now
const CLOSE_MODAL_ON_SUCCESS_IN_ACCOUNT_PAGES = false;

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ChangePassword",

		propTypes: {
			startOpen: PT.bool,
			cannotClose: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			beginChangePassword: function(opts = {}) {
				if (!this.state.isOpen) {
					this.openChangePassword(opts);
				}
			},
			// parent
			parentPasswordInvalid: function(error) {
				this.setState({
					isLoading: false,
					errorType: error,
					errorField: ["newPassword"],
				});
			},
			parentPasswordPending: function() {
				//Do nothing, isLoading state set during action below
			},
			parentPasswordSuccess: function() {
				if (
					CLOSE_MODAL_ON_SUCCESS_IN_ACCOUNT_PAGES &&
					this.state.forAccountPage
				) {
					// If on the account pages, immediately close to
					// match the behavior of other account page modals
					this.onClose();
				} else {
					this.setState({step: "confirmation", isLoading: false});
				}
			},
			parentPasswordFail: function(error) {
				this.setState({
					isLoading: false,
					errorType: error,
					errorField: error === "E_INVALID_PASSWORD" ? ["oldPassword"] : [],
				});
			},
			updateTempPasswordSuccess: function() {
				this.setState({
					step: "confirmation",
					isLoading: false,
					cannotClose: false,
				});
			},
			updateTempPasswordFail: function(error) {
				this.setState({
					errorType: error,
					isLoading: false,
					cannotClose: false,
				});
			},
			// student
			parentStudentPasswordInvalid: function(error) {
				this.setState({
					isLoading: false,
					errorType: error,
					errorField: ["newPassword"],
				});
			},
			parentStudentPasswordPending: function() {},
			parentStudentPasswordSuccess: function() {
				if (
					CLOSE_MODAL_ON_SUCCESS_IN_ACCOUNT_PAGES &&
					this.state.forAccountPage
				) {
					// If on the account pages, immediately close to
					// match the behavior of other account page modals
					this.onClose();
				} else {
					this.setState({step: "confirmation", isLoading: false});
				}
			},
			parentStudentPasswordFail: function(error) {
				this.setState({
					isLoading: false,
					errorType: error,
				});
			},
		},

		getInitialState: function() {
			this.inputs = {};
			return {
				displayName: null,
				step: "reset",
				isOpen: this.props.startOpen || false,
				oldPassword: "",
				newPassword: "",
				newPasswordRepeat: "",
				errorType: null,
				errorFields: [],
				isLoading: false,
				isTempPassword: false,
				forAccountPage: false,
			};
		},

		componentDidMount: function() {
			ImageLoader.preload(AssetsUtil.getOfficeCharacter("happy-fiona-grok"));
		},

		UNSAFE_componentWillReceiveProps: function(newProps) {
			if (newProps.startOpen && !this.state.isOpen) {
				this.openChangePassword();
			}
		},

		openChangePassword: function(opts = {}) {
			this.setState({
				displayName: opts.displayName,
				studentID: opts.studentID,
				step: "reset",
				isOpen: true,
				oldPassword: "",
				newPassword: "",
				newPasswordRepeat: "",
				errorType: null,
				errorFields: [],
				isLoading: false,
				isTempPassword: opts.isTempPassword,
				cannotClose: opts.isTempPassword,
				email: opts.email,
				// Option to make changes to the modal & flow for the account pages
				forAccountPage: opts.forAccountPage,
			});
		},

		onClose: function() {
			if (!this.state.cannotClose) {
				this.setState({isOpen: false});
			}
		},

		startLogin: function() {
			this.setState({isOpen: false});
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
				opts: {username: this.state.email},
			});
		},

		onReset: function() {
			if (!this.state.displayName && !this.state.oldPassword) {
				this.setState({
					errorType: "E_OLD_PASSWORD_MISSING",
					errorFields: ["oldPassword"],
				});
				this.focusInput("oldPassword");
			} else if (!this.state.newPassword) {
				this.setState({
					errorType: "E_NEW_PASSWORD_MISSING",
					errorFields: ["newPassword"],
				});
				this.focusInput("newPassword");
			} else if (!this.state.newPasswordRepeat) {
				this.setState({
					errorType: "E_NEW_PASSWORD_REPEAT_MISSING",
					errorFields: ["newPasswordRepeat"],
				});
				this.focusInput("newPasswordRepeat");
			} else if (this.state.newPassword !== this.state.newPasswordRepeat) {
				this.setState({
					errorType: "E_PASSWORD_MISMATCH",
					errorFields: ["newPasswordRepeat"],
				});
				this.focusInput("newPasswordRepeat");
			} else {
				if (this.state.displayName) {
					// For student
					this.props.dispatch({
						type: AT.PARENT_SAVE_STUDENT_PASSWORD_REQUEST,
						studentID: this.state.studentID,
						password: this.state.newPassword,
						passwordRepeat: this.state.newPasswordRepeat,
					});
				} else {
					// For parent
					this.props.dispatch({
						type: AT.SAVE_PARENT_PASSWORD_REQUEST,
						originalPassword: this.state.oldPassword,
						password: this.state.newPassword,
						passwordRepeat: this.state.newPasswordRepeat,
					});
				}
				this.setState({isLoading: true});
			}
		},

		handleKeyPress: function(evt, type) {
			const step = this.state.step;
			if (evt.which === 13) {
				if (type === "oldPassword") {
					this.focusInput("newPassword");
				} else if (type === "newPassword") {
					this.focusInput("newPasswordRepeat");
				} else if (type === "close") {
					this.onClose();
				} else if (step === "reset") {
					this.onReset();
				} else {
					this.onClose();
				}
			}
		},

		handleChange: function(evt, type) {
			const newState = {[type]: evt.target.value};
			if (this.state.errorType && _.includes(this.state.errorFields, type)) {
				newState.errorType = null;
				newState.errorFields = [];
			}
			this.setState(newState);
		},

		focusInput: function(type) {
			if (this.inputs[type]) {
				this.inputs[type].focus();
			}
		},

		renderInput: function(type, tabIndex) {
			const inputStyle =
				styles.input +
				(_.includes(this.state.errorFields, type) ? " " + styles.invalid : "");
			const placeholderOverride =
				this.state.isTempPassword && type === "oldPassword"
					? "Enter temporary password"
					: "";
			return (
				<input
					className={inputStyle}
					type={this.state.studentID ? "text" : "password"}
					placeholder={placeholderOverride || getResetCopy()[type]}
					value={this.state[type]}
					onChange={evt => this.handleChange(evt, type)}
					onKeyPress={evt => this.handleKeyPress(evt, type)}
					ref={i => (this.inputs[type] = i)}
					tabIndex={tabIndex}
					{...Analytics.getHotjarSuppressionAttributes()}
				/>
			);
		},

		renderResetContents: function() {
			let oldPasswordInput = null;
			if (!this.state.displayName) {
				oldPasswordInput = this.renderInput("oldPassword", 50);
			}
			return (
				<div className={styles.inputs}>
					{oldPasswordInput}
					{this.renderInput("newPassword", 51)}
					{this.renderInput("newPasswordRepeat", 52)}
				</div>
			);
		},

		renderConfirmation: function() {
			return (
				<img
					className={styles.successImg}
					src={AssetsUtil.getOfficeCharacter("happy-fiona-grok")}
				/>
			);
		},

		renderButtons: function(buttonAction, buttonText, step) {
			const {isLoading, forAccountPage} = this.state;
			if (forAccountPage && buttonText === "Submit") {
				//Switch default submit buttons to Save Changes with the button setting
				buttonText = "Save Changes";
			}
			const buttonClass = forAccountPage ? styles.twoButton : styles.button;
			let mainButton = (
				<div
					className={buttonClass}
					onClick={buttonAction}
					tabIndex={53}
					onKeyPress={evt => this.handleKeyPress(evt, "button")}
				>
					{buttonText}
				</div>
			);
			if (isLoading) {
				const loadingClass = forAccountPage
					? styles.twoLoadingContainer
					: styles.loadingContainer;
				mainButton = (
					<div className={loadingClass}>
						<div className={styles.loading}>
							<LoadingCircle colorType="white" />
						</div>
					</div>
				);
			}

			if (forAccountPage) {
				//Return a row with the main button & a cancel button
				const cancelButton = (
					<div
						className={buttonClass}
						onClick={this.onClose}
						tabIndex={54}
						onKeyPress={evt => this.handleKeyPress(evt, "close")}
					>
						Cancel
					</div>
				);
				return (
					<div className={styles.twoButtonRow}>
						{mainButton}
						{step !== "confirmation" && cancelButton}
					</div>
				);
			} else {
				// Otherwise, just have the main button
				return mainButton;
			}
		},

		render: function() {
			const {isOpen, step, errorType, isTempPassword} = this.state;
			//Decide the main contents of the step
			let contents = null;
			let errorMessage;
			let buttonAction;
			let buttonText;
			if (step === "reset") {
				contents = this.renderResetContents();
				errorMessage = CopyTable.getFormInvalidCopy("password")[errorType];
				buttonAction = this.onReset;
				buttonText = "Submit";
			} else if (step === "confirmation") {
				contents = this.renderConfirmation();
				buttonAction = isTempPassword ? this.startLogin : this.onClose;
				buttonText = isTempPassword ? "Sign in" : "Okay";
			}

			let errorClass = styles.error + " " + styles.errorLarge;
			if (!errorType) errorClass += " " + styles.errorHidden;
			const belowContents =
				step === "confirmation" ? null : (
					<div className={errorClass}>{errorMessage}</div>
				);

			if (isOpen) {
				const copy = getResetCopy(this.state.displayName)[step];
				return (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={true}
						portalContainer={null}
						level="overBar"
						modalClass={styles.main}
						cannotClose={this.state.cannotClose}
					>
						<div className={styles.container}>
							<div className={styles.aboveButton}>
								<div className={styles.title}>{copy.title}</div>
								<div className={styles.spacing} />
								{contents}
								{belowContents}
								<div className={styles.spacing} />
							</div>
							{this.renderButtons(buttonAction, buttonText, step)}
						</div>
					</OfficeModal>
				);
			} else {
				return null;
			}
		},
	})
);
